import React, { useState } from 'react';

const Register = (props) => {

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      fetch('https://mucksucker.com:3001/api/register', {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          firstName,
          lastName,
          company,
          email,
          password,
          passwordConfirm
        })
       })
       .then(response => response.text())
       .then(data => alert(data))
       .catch(err => alert(err));

    } catch(err) {
      alert(err);
    }
  };
  


  console.log(props);
    return (
      <div className="center">
        <h1>Register</h1>
        <div className="container">

          <form onSubmit={handleSubmit}>

            <div>

            <input
                type="text"
                placeholder="Company"
                value={company}
                onChange={(e) => setCompany(e.target.value)}  
              />

              <input
                type="text"
                placeholder="First name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}  
              />    
                
              <input
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}  
              />

              <input 
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}  
                />

                <input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}  
                />
                
                <input
                  type="password"
                  placeholder="Confirm Password"
                  value={passwordConfirm}
                  onChange={(e) => setPasswordConfirm(e.target.value)}  
                />
            </div>


            <button type="submit">Send Email</button>
          </form>


        </div>

      </div>
    )
  };
  
  export default Register;